import React from 'react';
import Img from './Img';

export function closeParentModal(e) {
    const modal = e.target.closest('[data-modal-id');
    if (modal == null) {
        return;
    }
    const id = parseInt(modal.getAttribute('data-modal-id'), 10);
    window.dispatchEvent(new CustomEvent('xs_closeModal', {detail: id}));
}

export default function Modal(props) {
    const handleClick = () => window.dispatchEvent(new CustomEvent('xs_closeModal', {detail: props.uniqueId}));
    
    return (
        <div className="c_38_1" data-type={props.type} data-modal-id={props.uniqueId}>
            <div className="c_38_1_1">
                <div className="c_38_1_1_1">{props.title}</div>
                <Img src="icon_close.svg" height="32px" width="32px" className="c_38_1_1_2" onClick={handleClick} />
            </div>
            <div className="c_38_1_2">
                {props.children}
            </div>
        </div>
    );
}
